import { 
    ContentWrapper, 
    BoxWrapper, 
    ConditionalWrapper,
    FlexWrapper
} from "../../components/Wrappers/Wrappers"
import { useState, useEffect } from "react"
import { Text, Title, DetailText } from "../../components/units/Text"
import { Divider } from "../../components/units/Divider"
import { useSignedInContext } from "../../context/AuthContextProvider"
import { useParams } from "react-router-dom"
import { 
    AcbOrg,
    AcbOrgPatch,
    AxiosGetAcbOrg,
    AxiosPatchAcbOrg
} from "../../components/Rest/RestPatchAcb"
import { Input } from "../../components/Form/FormInput"
import { SubmitButton } from "../../components/Buttons/buttons"
import { RestApiState } from "../../interfaces/Rest/types"
import { LgSelect } from "../../components/Form/FormInput"
import { useValidatePermission } from "../../roles/roles"

interface ResponseProps {
    requestState: RestApiState;
    timeOutId: NodeJS.Timeout | undefined;
}





export const AcbChangeOrganization = ():JSX.Element => {
    const { user } = useSignedInContext()
    const { serial_number } = useParams()
    useValidatePermission({role: user.role, resource: 'AcbView', action: 'changeOrganization'})
    if (!serial_number) {
        throw "serial number must be provided"
    }

    useEffect(() => {
        AxiosGetAcbOrg(user.role_slug, serial_number, setAcb)
    }, [])

    const [acb, setAcb] = useState<AcbOrg>({
        serial_number: null,
        organization_id: null,
        organizations: []
    })
    const [response, setResponse] = useState<ResponseProps>({
        requestState: RestApiState.Idle,
        timeOutId: undefined
    })

    const handleSubmit = (event: any) => {
        event.preventDefault();
        setResponse(prev => ({...prev, errors:{}}))

        const formData = new FormData(event.currentTarget)
        const formValues: Record<string, any> = {};
        formData.forEach((value, key) => {
            formValues[key] = value as any; // Cast value to string if necessary
        });

        setResponse(prev => ({...prev, requestState: RestApiState.Pending}))
        AxiosPatchAcbOrg(
            user.role_slug,
            serial_number,
            formValues as AcbOrgPatch, 
            setAcb,
            (value: RestApiState) => {
                setResponse(prev => ({...prev, requestState: value}))
            }
        )
    }

    return (
        <ContentWrapper>
            <DetailText href={`/react/acb/${serial_number}/edit`}> Назад </DetailText>
            <Title>Смена Организации</Title>
            <br />
            <BoxWrapper 
                bg="bg-primary"
                p="p2"
                r="r10"
                style={{
                    maxWidth: "640px"
                }} 
            >
            { acb && (
                <form onSubmit={ handleSubmit } className="show-up-quick">
                    <LgSelect name={"organization_id"}
                        label="Организация"
                        value={acb.organization_id ? acb.organization_id : undefined}
                        options={[
                            {value: '', label: "Не выбрано"},
                            ...acb.organizations.map(item => ({
                            value: item.id,
                            label: item.organization_name ? item.organization_name : '',
                        }))]}
                        valueSetter={ (e:any) => { 
                            setAcb(prev => ({...prev, organization_id: e.target.value}))}
                        }
                    />
                    <SubmitButton 
                        restState={response.requestState}
                        disabled={false}
                        restHandler={{
                            timeOutId: null,
                            setter: (key: "timeOutId" | "requestState", value: any) => {
                                setResponse(prev => ({...prev, [key]: value}))
                            }
                        }}
                    />
                </form>
            ) }
            </BoxWrapper>
        </ContentWrapper>
    )
}